import { useTranslation } from 'react-i18next'

import { toast } from '#/shared/ui/sonner'

import { copyToClipboard } from './copy-to-clipboard'

/** Copies a link to the clipboard and reports the result with a toast. */
export function useCopyLink(): (url: string) => Promise<void> {
  const { t } = useTranslation()
  return async (url: string) => {
    const copied = await copyToClipboard(url)
    if (copied) {
      toast.success(t('clipboard.linkCopied'))
    } else {
      toast.error(t('clipboard.copyFailed'))
    }
  }
}
